import React, { createContext, useContext, useState, useEffect } from "react";
import {
  UpdateDismissById,
  getStatusQueueByActorId,
} from "../Services/MemoService";
import { useUserContext } from "./UserContext";
import useLoading from "../hooks/useLoading";

type IMemoPageContextType = {
  processQue: number[];
  FailQue: memoQueStatus[];
  getMyMemoStatus: () => Promise<void>;
  onDismiss: (id: number) => Promise<void>;
  checkSyncMemo: () => void;
  
  isCheckFetch: boolean;
  setIsCheckFetch: (value: boolean) => void;
};

export type memoQueStatus = {
  id: number;
  memoId: number;
  jobId: number;
  actorId: number;
  state: string;
  documentNo: string;
  message: string;
};

export const MemoPageContext = createContext<IMemoPageContextType | null>(null);

export const MemoPageContextProvider: React.FC = (props) => {
  const [processQue, setProcessQue] = useState<number[]>([]);
  const [FailQue, setFailQue] = useState<memoQueStatus[]>([]);
  const [isCheck, setIsCheck] = useState(false);
  const [isCheckFetch, setIsCheckFetch] = useState(false);
  const { setLoad } = useLoading();
  const user = useUserContext();
    useEffect(() => {
    if (isCheck) {
      // const intervalId = setInterval(() => {
        getMyMemoStatus(true);
      // }, 5000);

      // return () => {
      //   clearInterval(intervalId);
      // };
    }
  }, [isCheck]);

  const getMyMemoStatus = async ( isAuto? : boolean ) => {
    try {
          const currentUser = user?.[0].EmployeeId;
    if (!currentUser) return;

    if (!isAuto) setLoad(true);
        const result: memoQueStatus[] = await getStatusQueueByActorId(currentUser);

       if (!result) {
        setLoad(false);
        return;
      } 
    const allSucceeded = result.every((e) => e.state === "Succeeded");
      const fail = result.filter((e) => e.state === "Failed");

      setProcessQue(
        result
          .filter((e) => e.state !== "Failed" && e.state !== "Succeeded")
          .map((e) => e.memoId)
      );
      setFailQue(fail);
      

      if (allSucceeded) {
        // trigger fetchWorklist หลังจากทุกอัน state "Succeeded"
        setLoad(false);
        setIsCheckFetch(true);
        setTimeout(() => setIsCheckFetch(false), 500);

        if (isAuto) setIsCheck(false);
        
      } else {
        // ถ้ายังไม่ Succeeded ทุกอัน ให้เรียก getMyMemoStatus อีกครั้ง หลัง 3 วิ
        setTimeout(() => getMyMemoStatus(true), 3000);
      }
    } catch (error) {
      console.error(error);      
      setLoad(false);
    }
  };

  const onDismiss = async (id: number) => {
    const result = await UpdateDismissById(id);
    getMyMemoStatus();
  };

  const checkSyncMemo = () => {
    setIsCheck(!isCheck);
  };

  return (
    <MemoPageContext.Provider
    value={{ processQue, FailQue, onDismiss, getMyMemoStatus, checkSyncMemo, isCheckFetch, setIsCheckFetch }}
    >
      {props.children}
    </MemoPageContext.Provider>
  );
};
